import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { getSeoForPath } from '../config/routeSeoMap';

/**
 * Applies route-specific meta from routeSeoMap when a page has no custom Helmet.
 * Page-level Helmet (child) overrides these tags via react-helmet-async.
 */
const RouteSEO = () => {
  const { pathname } = useLocation();
  const seo = getSeoForPath(pathname);

  if (!seo) return null;

  const title = seo.title.includes('Genzix') ? seo.title : `${seo.title} | Genzix`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={seo.description} />
      {seo.keywords && <meta name="keywords" content={seo.keywords} />}
      <link rel="canonical" href={seo.canonicalUrl} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={seo.ogUrl} />
      <meta property="og:type" content="website" />
      {seo.ogImage && <meta property="og:image" content={seo.ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      {seo.ogImage && <meta name="twitter:image" content={seo.ogImage} />}
      {seo.structuredData && (
        <script type="application/ld+json">{JSON.stringify(seo.structuredData)}</script>
      )}
    </Helmet>
  );
};

export default RouteSEO;
